<template>
	<section class="dalpha-keyword">
		<h3 class="dalpha-keyword__list-header">
			제외 시킬 키워드를 체크해주세요
			<span
				class="dalpha-keyword__desc"
				v-text="'해당 키워드는 전체갱신(3개월마다)시 초기화됩니다.'"
			/>
		</h3>
		<div class="dalpha-keyword__list-wrapper">
			<CheckboxList
				v-model="selectedKeywordIdList"
				:checkboxList="keywordList"
				:girdColumn="5"
			/>
		</div>
		<h3
			class="dalpha-keyword__selected-list-header"
			v-text="categoryTitle"
		/>
		<ul class="dalpha-keyword__selected-list">
			<li
				v-for="item in selectedKeywordList"
				:key="item.id"
				class="dalpha-keyword__selected-list-item"
			>
				{{ item.value }}
				<button
					class="dalpha-keyword__selected-list-item-delete-btn"
					@click="deleteKeyword(item.id)"
				>
					<i
						class="fas fa fa-times dalpha-keyword__selected-list-item-delete-icon"
					/>
				</button>
			</li>
		</ul>
	</section>
</template>
<script>
	import _ from 'lodash';
	import cloneDeep from 'lodash/cloneDeep';
	import { mapState } from 'vuex';
	import CheckboxList from '@/components/CheckboxList.vue';

	export default {
		name: 'DisplayDalphaKeyword',
		components: {
			CheckboxList,
		},
		data() {
			return {
				keywordList: [],
				keywordMapList: {},
				selectedKeywordIdListOrigin: [],
				selectedKeywordIdList: [],
			};
		},
		computed: {
			...mapState({
				curCateData: state => state.category.selection,
			}),
			curCateLevel() {
				return { category1st: 1, category2nd: 2, category3rd: 3 }[
					this.curCateData.depth
				];
			},
			categoryTitle() {
				const titleList =
					this.$store.getters['category/getSelectedCategoryNames'];
				return titleList.length === 0 ? '-' : titleList.join(' > ');
			},
			selectedKeywordList() {
				return this.selectedKeywordIdList.map(
					id => this.keywordMapList[id]
				);
			},
		},
		methods: {
			async initData() {
				try {
					this.$store.commit('toggleSpinner', true);
					const {
						data: { data },
					} = await this.$axiosAdmin2.get(
						`api/categories/level/${this.curCateLevel}/category/${this.curCateData.id}/dalpha-search-keywords`
					);
					this.keywordList = data.map(item => ({
						id: item.idKeyword,
						value: item.keywordText,
					}));
					this.keywordMapList = this.keywordList.reduce(
						(acc, { id, value }) => {
							acc[id] = { id, value };
							return acc;
						},
						{}
					);
					this.selectedKeywordIdList = data
						.filter(item => item.excludeChecked)
						.map(item => item.idKeyword);
					this.selectedKeywordIdListOrigin = cloneDeep(
						this.selectedKeywordIdList
					);
				} catch (err) {
					console.error(err);
					alert('달파키워드를 불러오는데 실패했습니다.');
				} finally {
					this.$store.commit('toggleSpinner', false);
				}
			},
			deleteKeyword(targetId) {
				this.selectedKeywordIdList = this.selectedKeywordIdList.filter(
					id => id !== targetId
				);
			},
			close() {
				this.$store.commit('modal/toggleModal', false);
				this.$store.commit('toggleSpinner', false);
			},
			async add() {
				try {
					this.$store.commit('toggleSpinner', true);
					const params = {
						insertExcludeIdKeywords: this.selectedKeywordIdList,
						deleteExcludeIdKeywords: this.keywordList
							.filter(item =>
								this.selectedKeywordIdList.every(
									selectedId => selectedId !== item.id
								)
							)
							.map(item => item.id),
					};
					await this.$axiosAdmin2.post(
						`/api/categories/level/${this.curCateLevel}/category/${this.curCateData.id}/dalpha-search-keywords`,
						params
					);
					this.$store.commit('category/refreshDalphaKeywords', {
						value: this.keywordList
							.filter(item =>
								this.selectedKeywordIdList.every(
									selectedId => item.id !== selectedId
								)
							)
							.map(item => item.value)
							.sort()
							.join(','),
					});
					alert('변경되었습니다.');
					this.close();
				} catch (err) {
					console.error(err);
					alert('적용하는데 실패했습니다.');
				} finally {
					this.$store.commit('toggleSpinner', false);
				}
			},
		},
		created() {
			this.initData();
		},
	};
</script>
<style lang="scss" scoped>
	.dalpha-keyword {
		&__list-header {
			margin: 8px 0;
			font-size: 20px;
		}

		&__desc {
			font-size: 14px;
		}

		&__list-wrapper {
			overflow-x: hidden;
			overflow-y: auto;
			height: 200px;
			margin-bottom: 2em;
			padding: 1.5em;
			border: 1px solid #303643;
			border-radius: 4px;
			line-height: 2em;
		}

		&__selected-list-header {
			margin: 8px 0;
			font-size: 20px;
		}

		&__selected-list {
			overflow-y: auto;
			display: flex;
			max-height: 120px;
			flex-wrap: wrap;
		}

		&__selected-list-item {
			display: flex;
			height: 44px;
			padding: 0 12px;
			margin: 0 12px 12px 0;
			border-radius: 24px;
			background: $btn-blue;
			align-items: center;
			line-height: 44px;
			color: #fff;
			font-weight: bold;
		}

		&__selected-list-item-delete-btn {
			display: flex;
			width: 20px;
			height: 20px;
			align-items: center;
			justify-content: center;
		}

		&__selected-list-item-delete-icon {
			font-size: 16px;
		}
	}
</style>
